/**
 * Routes where per-store content language is controlled by store settings (multiLanguageEnabled).
 *
 * @param {string} pathname
 * @returns {boolean}
 */
const isStoreLanguageRoute = (pathname) => {
    if (!pathname || pathname === '/' || pathname === '/login') {
        return false;
    }

    const storeOwnerEditPaths = [
        '/store/profile/edit',
        '/store/details/edit',
        '/store/theme/edit',
    ];

    if (storeOwnerEditPaths.includes(pathname)) {
        return true;
    }

    if (/^\/administration\/store\/qr\/[^/]+$/.test(pathname)) {
        return true;
    }

    const storePublicPatterns = [
        /^\/store\/[^/]+$/,
        /^\/store\/contact\/[^/]+$/,
        /^\/store\/about\/[^/]+$/,
        /^\/store\/qr\/[^/]+$/,
    ];

    return storePublicPatterns.some((pattern) => pattern.test(pathname));
};

export default isStoreLanguageRoute;
